import Axios from "axios";
import moment from "moment";
import { latLng } from "leaflet";

const state = () => ({
  absen: [],
  map: [],
  info: {},
  code: null,
  message: null,
  status: null,
  loading: false,
  host: process.env.VUE_APP_API_HOST || 'http://localhost:8020',
});

const mutations = {
  set_absen(state, absen){
    state.absen = absen
  },
  set_map(state, map){
    state.map = map
  },
  set_info(state, info){
    state.info = info
  },
  set_code(state, code){
    state.code = code
  },
  set_message(state, message){
    state.message = message
  },
  set_status(state, status){
    state.status = status
  },
  set_loading(state, loading){
    state.loading = loading
  }
};

const actions = {
  get_rekapan({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);
      // commit("set_info", {});

      let tanggal = moment(data.tanggal).format("YYYY-MM-DD");

      let url = state.host+"/persuratan/laporan/daftarunit/"+tanggal;
      let headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
      Axios.get(url, { headers: headers })
        .then((response) => {
          const data_absen = response.data;

          const absen = [];
          const map = [];
          // const info = [];
  
          for (let i = 0; i < data_absen.length; i++) {
            const element = data_absen[i];
            absen.push({id: element.id, nip: element.nip, nama: element.nama, eselonDua: element.eselonDua, tanggal: element.tanggal, absenMasuk: element.absenMasuk, absenSiang: element.absenSiang, absenPulang: element.absenPulang, absenMasukSitkp: element.absenMasukSitkp, absenSiangSitkp: null, absenPulangSitkp: element.absenPulangSitkp, kondisi: element.kondisi, kegiatan: element.kegiatan, output: element.output, progres: element.progres, unit: element.unit, lokasi: element.lokasi, longitude: element.longitude, latitude: element.latitude, status: element.status, keterangan: element.keterangan, longitudeSiang: element.longitudeSiang, latitudeSiang: element.latitudeSiang, lokasiSiang: element.lokasiSiang, longitudePulang: element.longitudePulang, latitudePulang: element.latitudePulang, lokasiPulang: element.lokasiPulang, koordinat_masuk: latLng(element.latitude, element.longitude), koordinat_siang: latLng(element.latitudeSiang, element.longitudeSiang), koordinat_pulang: latLng(element.latitudePulang, element.longitudePulang)}); 
            map.push({nip: element.nip, nama: element.nama, koordinat_masuk: latLng(element.latitude, element.longitude), koordinat_siang: latLng(element.latitudeSiang, element.longitudeSiang), koordinat_pulang: latLng(element.latitudePulang, element.longitudePulang)})
            // if (data.nip == element.nip) {
              // info.push({koordinat_masuk: latLng(element.latitude, element.longitude)});
              // let koordinat_masuk = latLng(element.latitude, element.longitude)
              // commit("set_info", {koordinat_masuk: latLng(element.latitude, element.longitude)});
            // }
          }

          commit("set_loading", false);
          commit("set_absen", absen);
          commit("set_map", map);
          // commit("set_info", info);
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("token");
            delete Axios.defaults.headers.common["Authorization"];
            this.$router.push({ name: "home" });
          }
          commit('set_message', error.response.data.error_description)
          commit("set_loading", false);
          reject(error);
        });
    });
  },
  get_hari_ini({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/persuratan/laporan";
      let headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
      Axios.get(url, { headers: headers })
        .then((response) => {
          const data_absen = response.data;

          let absen = {};

          if (data_absen.length != 0) {
            absen = {id: data_absen.id, nip: data_absen.nip, nama: data_absen.nama, eselonDua: data_absen.eselonDua, tanggal: data_absen.tanggal, absenMasuk: data_absen.absenMasuk, absenSiang: data_absen.absenSiang, absenPulang: data_absen.absenPulang, absenMasukSitkp: data_absen.absenMasukSitkp, absenSiangSitkp: null, absenPulangSitkp: data_absen.absenPulangSitkp, kondisi: data_absen.kondisi, kegiatan: data_absen.kegiatan, output: data_absen.output, progres: data_absen.progres, unit: data_absen.unit, lokasi: data_absen.lokasi, longitude: data_absen.longitude, latitude: data_absen.latitude, status: data_absen.status, keterangan: data_absen.keterangan, longitudeSiang: data_absen.longitudeSiang, latitudeSiang: data_absen.latitudeSiang, lokasiSiang: data_absen.lokasiSiang, longitudePulang: data_absen.longitudePulang, latitudePulang: data_absen.latitudePulang, lokasiPulang: data_absen.lokasiPulang, koordinat_masuk: latLng(data_absen.latitude, data_absen.longitude), koordinat_siang: latLng(data_absen.latitudeSiang, data_absen.longitudeSiang), koordinat_pulang: latLng(data_absen.latitudePulang, data_absen.longitudePulang)};
          }

          commit("set_loading", false);
          commit("set_absen", absen);
          // commit("set_info", absen);
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("token");
            delete Axios.defaults.headers.common["Authorization"];
            this.$router.push({ name: "home" });
          }
          commit('set_message', error.response.data.error_description)
          commit("set_loading", false);
          reject(error);
        });
    });
  },
  get_per_bulan({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/persuratan/laporan/daftar";
      let headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
      Axios.get(url, { headers: headers })
        .then((response) => {
          const data_absen = response.data;

          const absen = [];
  
          for (let i = 0; i < data_absen.length; i++) {
            const element = data_absen[i];

            let bulan = moment(element.tanggal).format("M");
            let tahun = moment(element.tanggal).format("YYYY");

            absen.push({id: element.id, nip: element.nip, nama: element.nama, eselonDua: element.eselonDua, tanggal: element.tanggal, bulan: bulan, tahun: tahun, absenMasuk: element.absenMasuk, absenSiang: element.absenSiang, absenPulang: element.absenPulang, absenMasukSitkp: element.absenMasukSitkp, absenSiangSitkp: null, absenPulangSitkp: element.absenPulangSitkp, kondisi: element.kondisi, kegiatan: element.kegiatan, output: element.output, progres: element.progres, unit: element.unit, lokasi: element.lokasi, longitude: element.longitude, latitude: element.latitude, status: element.status, keterangan: element.keterangan, longitudeSiang: element.longitudeSiang, latitudeSiang: element.latitudeSiang, lokasiSiang: element.lokasiSiang, longitudePulang: element.longitudePulang, latitudePulang: element.latitudePulang, lokasiPulang: element.lokasiPulang, koordinat_masuk: latLng(element.latitude, element.longitude), koordinat_siang: latLng(element.latitudeSiang, element.longitudeSiang), koordinat_pulang: latLng(element.latitudePulang, element.longitudePulang)}); 
          }

          commit("set_loading", false);
          commit("set_absen", absen);
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("token");
            delete Axios.defaults.headers.common["Authorization"];
            this.$router.push({ name: "home" });
          }
          commit('set_message', error.response.data.error_description)
          commit("set_loading", false);
          reject(error);
        });
    });
  },
  update_kegiatan_output_progress: function({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let form_kegiatan = { kondisi: data.kondisi, kegiatan: data.kegiatan, output: data.output, progres: data.progress };

      let formData = new FormData();
      formData.append("laporanJson", JSON.stringify(form_kegiatan));

      let url = state.host+"/persuratan/laporan/simpan";
      let headers = { Authorization: "Bearer " + localStorage.getItem("token") };

      Axios.post(url, formData, { headers: headers })
        .then((response) => {
          commit("set_loading", false);
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("token");
            delete Axios.defaults.headers.common["Authorization"];
            this.$router.push({ name: "home" });
          }
          commit('set_message', error.response.data.error_description)
          commit("set_loading", false);
          reject(error);
        });
    });
  },
  post_absen_masuk: function({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/persuratan/laporan/checkingps";

      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      const formLoc = { longitude: data.longitude, latitude: data.latitude, lokasi: null };

      const formLocation = new FormData();
      formLocation.append("lokasiJson", JSON.stringify(formLoc));

      Axios.post(url, formLocation, { headers: headers })
        .then((response) => {
          commit("set_loading", false);
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("token");
            delete Axios.defaults.headers.common["Authorization"];
            this.$router.push({ name: "home" });
          }
          commit("set_loading", false);
          reject(error);
        });
    });
  },
  post_absen_siang: function({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/persuratan/laporan/checkinsianggps";

      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      const formLoc = { longitude: data.longitude, latitude: data.latitude, lokasi: null };

      const formLocation = new FormData();
      formLocation.append("lokasiJson", JSON.stringify(formLoc));

      Axios.post(url, formLocation, { headers: headers })
        .then((response) => {
          commit("set_loading", false);
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("token");
            delete Axios.defaults.headers.common["Authorization"];
            this.$router.push({ name: "home" });
          }
          commit("set_loading", false);
          reject(error);
        });
    });
  },
  post_absen_pulang: function({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/persuratan/laporan/checkoutgps";

      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      const formLoc = { longitude: data.longitude, latitude: data.latitude, lokasi: null };

      const formLocation = new FormData();
      formLocation.append("lokasiJson", JSON.stringify(formLoc));

      Axios.post(url, formLocation, { headers: headers })
        .then((response) => {
          commit("set_loading", false);
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("token");
            delete Axios.defaults.headers.common["Authorization"];
            this.$router.push({ name: "home" });
          }
          commit("set_loading", false);
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};